/** @file useApi: the editor's server calls from ApiContext, or null when there is no server. */
import { useContext } from 'react';
import type { EditorApi } from '../store/editorApi';
import { ApiContext } from './apiContext';

/** The api `App` provides; screens show a "no server" state when it is null. */
export function useApi(): EditorApi | null {
  return useContext(ApiContext);
}
